<div [id]="id['grid']" class="col-xs-12 sp-0" [style.height]="'100%'" (click)="gridService.setActiveGrid(id['grid'])">
    <ag-grid-angular
        *ngIf="rowModelType && gridStateReady"
        [rowDragManaged]="true"
        (rowDragEnd)="onRowDragEnd($event)"
        [suppressMoveWhenRowDragging]="false"
        [initialState]="gridState"
        [autoGroupColumnDef]="autoGroupColumnDef"
        [groupRowRendererParams]="autoGroupColumnDef.cellRendererParams"
        [domLayout]="domLayout"
        [icons]="icons"
        [sideBar]="sidebarDefinition"
        [defaultColDef]="defaultColumnDefinitions"
        [dataTypeDefinitions]="dataTypeDefinitions"
        [excelStyles]="excelStyles"
        [enableRangeSelection]="true"
        columnMenu="new"
        [components]="components"
        [columnTypes]="columnTypes"
        [columnDefs]="options.data!.columnDefinitions"
        [copyHeadersToClipboard]="false"
        [groupLockGroupColumns]="groupColumnsLocked"
        [groupDisplayType]="options.config?.groupDisplayType ?? 'multipleColumns'"
        [groupDefaultExpanded]="groupDefaultExpanded"
        [localeText]="localeText"
        [rowSelection]="rowSelection"
        [rowModelType]="rowModelType"
        [maintainColumnOrder]="true"
        pivotRowTotals="after"
        pivotColumnGroupTotals="before"
        [getRowClass]="getRowClass"
        [serverSideDatasource]="serverSideDataSource"
        [cacheBlockSize]="cacheBlockSize"
        [singleClickEdit]="true"
        [suppressCopySingleCellRanges]="false"
        [tooltipTrigger]="options.config?.tooltip?.trigger ?? 'hover'"
        [tooltipShowDelay]="options.config?.tooltip?.showDelay ?? 2000"
        [tooltipHideDelay]="options.config?.tooltip?.hideDelay ?? 10000"
        [getRowId]="getRowId"
        [processPivotResultColDef]="processPivotResultColDef"
        [processPivotResultColGroupDef]="processPivotResultColGroupDef"
        [pagination]="options.kendo?.pageable ?? true"
        [paginationPageSize]="20"
        [paginationPageSizeSelector]="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 250, 500]"
        [pivotMode]="options.config?.pivotMode ?? false"
        [enterNavigatesVerticallyAfterEdit]="this.options.config?.navigation?.altNav !== true ? true : false"
        [stopEditingWhenCellsLoseFocus]="true"
        [loadingOverlayComponent]="loadingOverlayComponent"
        (filterChanged)="onFilterChanged($event)"
        (cellKeyDown)="onCellKeyDown($event)"
        (cellClicked)="onCellClicked($event)"
        (cellDoubleClicked)="onCellDoubleClicked($event)"
        (cellValueChanged)="onCellValueChanged($event)"
        (cellEditingStarted)="onCellEditingStarted($event)"
        (cellEditingStopped)="onCellEditingStopped($event)"
        [undoRedoCellEditing]="true"
        [undoRedoCellEditingLimit]="25"
        (rowSelected)="onRowSelected($event)"
        [rowClassRules]="rowClassRules"
        (firstDataRendered)="onFirstDataRendered($event)"
        (modelUpdated)="onModelUpdated($event)"
        (gridReady)="onGridReady($event)"
        (stateUpdated)="onStateUpdated($event)"
        (gridColumnsChanged)="onGridColumnsChanged()"
        [processCellForClipboard]="processCellForClipboard"
        [processCellFromClipboard]="processCellFromClipboard"
        [processDataFromClipboard]="processDataFromClipboard"
        [popupParent]="popupParent"
        [ngClass]="(options.config?.css?.theme ?? gridTheme) + ' ' + options.config?.css?.compactness"
        [ngStyle]="style['grid']"
        [style.--ag-font-size]="options.config?.css?.fontsize ?? 'var(--tt-font-size)'"
        [style.--ag-selected-row-background-color]="'rgba(33, 150, 243, 0.3)'"
    >
    </ag-grid-angular>

    <tt-grid-toolbar
        #toolbar
        [grid]="this"
        [ttProjectedMenus]="toolbarMenus"
        [ttColschemaToolbar]="dbGridOptions?.toolbar"
        [ttButtons]="ttOptions.config?.toolbar?.buttons"
        [ttToggles]="ttOptions.config?.toolbar?.toggles"
    >
        <ng-container toolbarButtons>
            <ng-content select="[toolbarButtons]"></ng-content>
        </ng-container>
    </tt-grid-toolbar>

    <!-- <div
        #toolbar
        [hidden]="options.config?.toolbar?.hidden !== false"
        class="ag-header ag-header-row tt-grid__toolbar"
        role="row"
        aria-rowindex="0"
        style="display: block; top: 0; left: 0; height: fit-content; min-height: fit-content; width: 100%; overflow: visible; z-index: 3"
    >
        <ng-container *ngIf="options.data!.columnDefinitions.length > 0 && initializationComplete">
            <button
                *ngFor="let button of toolbarButtons"
                [hidden]="(button.disabled$ | async) === 'hidden'"
                [matTooltip]="button.translate === true && !!button.ariaLabel ? translations[button.ariaLabel] : !!button.ariaLabel ? button.ariaLabel : ''"
                [matTooltipShowDelay]="500"
                class="ag-button ag-floating-filter-button-button tt-grid__toolbar-button"
                (click)="button.func($event)"
            >
                <span [ngClass]="gridService.getIconClasses(button.icon)" style="font-size: 2rem"></span>
                <span *ngIf="!!button.secondIcon" class="fa-fw" [ngClass]="button.secondIcon"></span>
            </button>

            <ng-container *ngFor="let button of options.config?.toolbar?.buttons">
                <button
                    *ngIf="button.name.startsWith('§print')"
                    [hidden]="(button.disabled$ | async) == 'hidden'"
                    [matTooltip]="button?.ariaLabel || ''"
                    [matTooltipShowDelay]="500"
                    class="tt-grid__toolbar-button--custom"
                    [ngClass]="!!button.cssClass ? button.cssClass : 'ag-button ag-floating-filter-button-button tt-grid__toolbar-button'"
                    [disabled]="button.disabled$ | async"
                    (click)="openPrintDialog(button)"
                    [style.fontSize]="'calc(var(--ag-font-size) - 2px)'"
                >
                    <span class="fa-fw" [ngClass]="'fal fa-print'" style="font-size: 2em"></span>
                    <span [style.fontSize]="'var(----ag-grid-fontSize)'" *ngIf="button.text">{{ button.translate === true ? translations[button.text] : button.text }}</span>
                </button>
                <button
                    *ngIf="!button.name.startsWith('§print')"
                    [hidden]="(button.disabled$ | async) == 'hidden'"
                    [matTooltip]="button?.ariaLabel || ''"
                    [matTooltipShowDelay]="500"
                    class="tt-grid__toolbar-button--custom"
                    [ngClass]="!!button.cssClass ? button.cssClass : 'ag-button ag-floating-filter-button-button tt-grid__toolbar-button'"
                    [disabled]="button.disabled$ | async"
                    (click)="button._func?.($event)"
                    [style.fontSize]="'calc(var(--ag-font-size) - 2px)'"
                >
                    <span
                        class="fa-fw"
                        [ngClass]="gridService.getIconClasses(button.icon) + (button.spinOnAction === true && button._processing === true ? ' fa-spin ' : '')"
                        style="font-size: 1.6rem"
                    ></span>
                    <span [style.fontSize]="'var(----ag-grid-fontSize)'" *ngIf="button.text">{{ button.translate === true ? translations[button.text] : button.text }}</span>
                </button>
            </ng-container>

            <ng-container *ngFor="let toggle of options.config?.toolbar?.toggles">
                <button
                    [hidden]="(toggle.disabled$ | async) == 'hidden'"
                    class="tt-grid__toolbar-button--custom"
                    [ngClass]="!!toggle.cssClass ? toggle.cssClass : 'ag-button ag-floating-filter-button-button tt-grid__toolbar-button'"
                    [disabled]="toggle.disabled$ | async"
                    (click)="toggle.states[toggle.state ?? 0]._func?.()"
                    [style.fontSize]="'calc(var(--ag-font-size) - 2px)'"
                >
                    <span class="fa-fw" [ngClass]="gridService.getIconClasses(toggle.states[toggle.state ?? 0].icon)" style="font-size: 1.6rem"></span>
                    <span [style.fontSize]="'var(----ag-grid-fontSize)'" *ngIf="toggle.states[toggle.state ?? 0].text">{{
                        toggle.states[toggle.state ?? 0].translate !== false ? translations[toggle.states[toggle.state ?? 0].text] : toggle.states[toggle.state ?? 0].text
                    }}</span>
                </button>
            </ng-container>

            <ng-container *ngIf="appSettings.settings.user?.portalUserKeynoEdit === 142">
                <tt-overflow-menu>
                    <tt-overflow-menu-item ttText="test" ttIcon="fa-unicorn"></tt-overflow-menu-item>
                    <tt-overflow-menu-item ttText="test" ttIcon="fa-unicorn"></tt-overflow-menu-item>
                    <tt-overflow-menu-item ttText="test" ttIcon="fa-unicorn"></tt-overflow-menu-item>
                    <tt-overflow-menu-item ttText="test" ttIcon="fa-unicorn"></tt-overflow-menu-item>
                </tt-overflow-menu>
            </ng-container>
        </ng-container>
    </div> -->
</div>
